export default "__VITE_ASSET__CHo4cI7c__"